export default __webpack_public_path__ + "static/media/izban.9b1f435a.png";